import * as type from '../actions/types';

const initialState = {
  fetching: false,
  data: {},
  error: false,
  errorMessage: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_DEAL_PENDING:
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
      };
    case type.FETCH_DEAL_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: action.payload,
        success: true,
      };
    case type.FETCH_DEAL_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };

    case type.CLEAR_DEAL:
      return {
        ...state,
        fetching: false,
        data: {},
        error: false,
        errorMessage: '',
        success: false,
      };

    default:
      return state;
  }
};
